import Relay from 'react-relay';

export default class NetworkLayer extends Relay.DefaultNetworkLayer {
    constructor(...args) {
        super(...args);
    }

    setToken(token) {
        this.token = token;

        this._init.headers = {
            ...this._init.headers,
            Authorization: token,
        }
    }
}


// WEBPACK FOOTER //
// ./src/NetworkLayer.js